import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import ThoughtCard from '../ThoughtCard/ThoughtCard';
import './ThoughtFeed.scss';
var ThoughtFeed = function (props) {
    var THOUGHT_CATCHER = useControllers().THOUGHT_CATCHER;
    useOnMount(function () {
        THOUGHT_CATCHER.getStaticPublicThoughts();
        // THOUGHT_CATCHER.getLatestPublicThoughts();
    });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "ThoughtFeed" }, THOUGHT_CATCHER.thoughtSnapshots.map(function (thought) { return React.createElement(ThoughtCard, { key: thought.id, thought: thought }); }))); } });
};
export default ThoughtFeed;
